/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  InternalServerError,
  SalesOfficesResponse,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    SalesOfficesResponseFromJSON,
    SalesOfficesResponseToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface GetSalesOfficesRequest {
    companyId: string;
    sort?: GetSalesOfficesSortEnum;
}

/**
 * 
 */
export class SalesOfficesApi extends runtime.BaseAPI {

    /**
     * 営業所一覧取得
     */
    async getSalesOfficesRaw(requestParameters: GetSalesOfficesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesOfficesResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getSalesOffices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sales-offices`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesOfficesResponseFromJSON(jsonValue));
    }

    /**
     * 営業所一覧取得
     */
    async getSalesOffices(requestParameters: GetSalesOfficesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesOfficesResponse> {
        const response = await this.getSalesOfficesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSalesOfficesSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetSalesOfficesSortEnum = typeof GetSalesOfficesSortEnum[keyof typeof GetSalesOfficesSortEnum];
